export default class MobiEnvironment {
    constructor() {
        let appSettings = require('../appsettings.json');
        this.mobiUrl = '';

        switch (appSettings.Environment) {
            case 'Test':
                this.mobiUrl = 'http://amp-test.tuppafrica.co.za';
                break;
            case 'Production':
                this.mobiUrl = 'https://amp.tuppafrica.co.za';
                break;
            case 'Dev':
                this.mobiUrl = 'http://localhost:3000';
                break;
            default:
                break;
        }
    }

    GetMobiUrl() {
        return this.mobiUrl;
    }
    
}